import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import ".././../styles/diet/diet.css";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import DietTypesFilters from "../../components/diet/types/DietTypesFilters";
import DietTypesTable from "../../components/diet/types/DietTypesTable";
import { selectAuth } from "../../components/auth/auth.selector";
import {
  fetchDietPreferenceData,
  fetchDietTypesData,
} from "../../redux/reducers/apiSlice";
import HelmetWrapper from "../../HelmetWrapper";

const DietType = () => {
  const dispatch = useDispatch();
  const { dietTypesData, dietPreferenceData } = useSelector(
    (state) => state.api
  );
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const initialDTfilters = {
    searchString: "",
  };
  const [dtFilters, setDTFilters] = useState(initialDTfilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [sendableQPs, setSendableQPs] = useState("");
  const initialDT = {
    isPage: 0,
    pagination: [],
    allDietTypes: [],
  };
  const [allDTs, setAllDTs] = useState(initialDT);
  const [allDPs, setAllDPs] = useState(initialDT);

  const onClickSearch = () => {
    setSearchFilterApplied(true);
    const searchQP = dtFilters.searchString
      ? `&search=${dtFilters.searchString}`
      : "";

    setSendableQPs((prevQP) => prevQP + searchQP);
  };

  useEffect(() => {
    dispatch(
      fetchDietTypesData({
        pageNo: allDTs.isPage + 1,
        limit: 10,
        queryParameters: sendableQPs,
        token: decryptedText?.token,
      })
    );
  }, [sendableQPs, allDTs.isPage]);

  useEffect(() => {
    dispatch(
      fetchDietPreferenceData({
        pageNo: allDPs.isPage + 1,
        limit: 10,
        queryParameters: sendableQPs,
        token: decryptedText?.token,
      })
    );
  }, [sendableQPs, allDPs.isPage]);

  useEffect(() => {
    if (searchFilterApplied && dtFilters.searchString?.length === 0) {
      setSendableQPs("");

      dispatch(
        fetchDietTypesData({
          pageNo: 1,
          limit: 10,
          queryParameters: sendableQPs?.replace(/&?search=[^&]*/, ""),
          token: decryptedText?.token,
        })
      );
      dispatch(
        fetchDietPreferenceData({
          pageNo: allDPs.isPage + 1,
          limit: 10,
          queryParameters: sendableQPs?.replace(/&?search=[^&]*/, ""),
          token: decryptedText?.token,
        })
      );
      setSearchFilterApplied(false);
    }
  }, [dtFilters.searchString]);

  useEffect(() => {
    if (dietTypesData?.status && dietTypesData?.data?.length > 0) {
      const { data, pagination } = dietTypesData || {};

      setAllDTs({
        ...allDTs,
        allDietTypes: data || [],
        pagination: pagination || [],
      });
    } else {
      setAllDTs({
        ...allDTs,
        allDietTypes: [],
        pagination: [],
      });
    }

    if (dietPreferenceData?.status && dietPreferenceData?.data?.length > 0) {
      const { data, pagination } = dietPreferenceData || {};

      setAllDPs({
        ...allDTs,
        allDietTypes: data || [],
        pagination: pagination || [],
      });
    } else {
      setAllDPs({
        ...allDTs,
        allDietTypes: [],
        pagination: [],
      });
    }
  }, [dietTypesData, dietPreferenceData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <HelmetWrapper title="WTF: Diet Type">
      <Container
        className="bg-cloud-k dietMealsParentContainer dietTypes px-50px"
        fluid
      >
        <Row>
          <Col>
            <DietTypesFilters
              filters={dtFilters}
              setFilters={setDTFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              callFunction={() =>
                dispatch(
                  fetchDietTypesData({
                    pageNo: 1,
                    limit: 10,
                    queryParameters: sendableQPs,
                    token: decryptedText?.token,
                  })
                )
              }
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <MealsStructure text={"Diet type"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <DietTypesTable
              decryptedText={decryptedText}
              allDatas={allDTs}
              setAllDatas={setAllDTs}
              callFunction={() => {
                dispatch(
                  fetchDietTypesData({
                    pageNo: 1,
                    limit: 10,
                    queryParameters: sendableQPs,
                    token: decryptedText?.token,
                  })
                );
                dispatch(
                  fetchDietPreferenceData({
                    pageNo: 1,
                    limit: 10,
                    queryParameters: sendableQPs,
                    token: decryptedText?.token,
                  })
                );
              }}
              isDietType={true}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <MealsStructure text={"Diet preferences"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <DietTypesTable
              decryptedText={decryptedText}
              allDatas={allDPs}
              setAllDatas={setAllDPs}
              callFunction={() => {
                dispatch(
                  fetchDietTypesData({
                    pageNo: 1,
                    limit: 10,
                    queryParameters: sendableQPs,
                    token: decryptedText?.token,
                  })
                );
                dispatch(
                  fetchDietPreferenceData({
                    pageNo: 1,
                    limit: 10,
                    queryParameters: sendableQPs,
                    token: decryptedText?.token,
                  })
                );
              }}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DietType;
